import classnames from "classnames";
import defer from "lodash/defer";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as actions from "../actions/actions";
import { modalTypes } from "../constants/modalTypes";
import { licenses, phases } from "../reducers/download";
import IconRelatedIcons from "./download-flow/icon-related-icons";
import IconShare from "./download-flow/icon-share";
import IconTags from "./download-flow/icon-tags";
import EditorControls from "./editor/editor-controls";
import { SuperUserActions } from "./fort-super-user-actions";
import IconDownloadFlow from "./nounproject-icon-download-flow";
import IconView from "./nounproject-icon-view";

class NounProjectIconHero extends React.Component {
    constructor(props) {
        super(props);

        this.containerEl = null;
        this.setContainerEl = this.setContainerEl.bind(this);
        this.state = {};
    }

    componentWillReceiveProps(nextProps) {
        let { location, inModal } = this.props;
        let { location: nextLocation } = nextProps;
        let { state: historyState } = location;
        let { state: nextHistoryState } = nextLocation;

        historyState = historyState || {};
        nextHistoryState = nextHistoryState || {};
        if (!inModal) {
            if (historyState.modal != nextHistoryState.modal) {
                if (nextHistoryState.modal) {
                    if (historyState.modal == modalTypes.ICON_SHARE) {
                        this.props.dismissModal(historyState.modal);
                    }
                    let modalProps = {
                        ...nextProps
                    };

                    nextProps.downloadFlowModalStep(
                        nextProps.history,
                        nextHistoryState.modal,
                        modalProps
                    );
                } else {
                    if (nextProps.modalOpen) {
                        this.props.dismissModal();
                    }
                }
            }
        }
        if (nextProps.icon) {
            if (
                !nextProps.download.pendingDownload ||
                nextProps.download.pendingDownload.id != nextProps.icon.id
            ) {
                // dismiss all modals (auth, share, download flow)
                nextProps.dismissModal();
                if (!nextProps.inModal) {
                    // Restart the download flow for the new icon
                    // but only for the non-modal download flow so
                    // that this action only gets dispatched once
                    this.props.downloadSetFlowActive(nextProps.icon);
                }
            }
        }

        if (
            this.props.download.waitingForAuth &&
            !nextProps.download.waitingForAuth
        ) {
            if (this.props.refetchIcon) {
                this.props.refetchIcon();
            }
        }

        if (
            !this.shouldShowInModal(this.props) &&
            this.shouldShowInModal(nextProps)
        ) {
            if (nextHistoryState.modal != modalTypes.DOWNLOAD_FLOW) {
                nextProps.downloadFlowNavigateToModalStep(
                    nextProps.history,
                    modalTypes.DOWNLOAD_FLOW
                );
            }
        }
    }

    shouldShowInModal(props) {
        let { download } = props;

        let { status } = download;

        if (!props.showInModal) {
            return false;
        }

        if (download.isPremiumUser) {
            return false;
        }

        return (
            status &&
            status != phases.INITIAL &&
            status != phases.DOWNLOAD_READY
        );
    }

    setContainerEl(el) {
        this.containerEl = el;

        if (this.props.scrollToElement && this.state.wantsScroll) {
            this.props.uiScrollToElement(this.containerEl);
        } else {
        }
    }

    componentDidMount() {
        if (this.props.scrollToElement) {
            if (this.containerEl) {
                this.props.uiScrollToElement(this.containerEl);
            } else {
                this.setState({
                    wantsScroll: true
                });
            }
        }
        let { location, inModal, history } = this.props;
        if (!inModal) {
            if (location.state && location.state.modal) {
                this.props.downloadFlowHideModal(history);
            }
        }

        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.scrollToElement) {
            if (prevProps.icon && this.props.icon) {
                if (this.props.icon.id != prevProps.icon.id) {
                    this.props.uiScrollToElement(this.containerEl);
                }
            }

            if (
                this.props.showInModal &&
                prevProps.status != this.props.status
            ) {
                if (this.props.status == phases.INITIAL) {
                    defer(() => {
                        this.props.uiScrollToElement(this.containerEl);
                    });
                }
            }

            let prevUserAnonymous = prevProps.isAnonymous;
            let userIsAnonymous = this.props.isAnonymous;
            if (prevUserAnonymous && !userIsAnonymous) {
                this.props.uiScrollToElement(this.containerEl);
            }
        }
    }

    handleCloseClick = e => {
        if (!this.props.processing) {
            this.props.onCloseAction();
        }
    };

    render() {
        let { status, license, usingPremiumFeatures } = this.props;

        let superUserActions;
        if (this.props.icon) {
            if (!this.props.icon.isActive) {
                return null;
            }

            if (
                this.props.icon &&
                this.props.currentUser !== undefined &&
                this.props.currentUser.is_superuser
            ) {
                let uploaderId =
                    this.props.icon.uploader_id ||
                    (this.props.icon.uploader && this.props.icon.uploader.id);
                superUserActions = (
                    <SuperUserActions
                        superUser={this.props.currentUser.is_superuser}
                        iconId={this.props.icon.id}
                        uploaderId={uploaderId}
                    />
                );
            }

            let closeButton,
                heroPreview,
                heroEditing,
                heroMeta,
                iconCollections,
                withAttribution;

            if (this.props.onCloseAction) {
                closeButton = (
                    <div
                        className="esc-page ui_close"
                        title="Close this menu"
                        onClick={this.handleCloseClick}
                    />
                );
            }

            withAttribution =
                license == licenses.CREATIVE_COMMONS && status != phases.UPSELL;

            if (this.props.icon) {
                heroPreview = (
                    <IconView
                        icon={this.props.icon}
                        withAttribution={withAttribution}
                    />
                );
            }

            heroMeta = (
                <IconDownloadFlow
                    inModal={this.props.inModal}
                    showInModal={this.props.showInModal}
                    collection={this.props.collection}
                    icon={this.props.icon}
                    refetchIcon={this.props.refetchIcon}
                    onCloseAction={this.props.onCloseAction}
                />
            );

            heroEditing = <EditorControls />;

            let viewMore;
            if (
                (status == phases.INITIAL || status == phases.DOWNLOAD_READY) &&
                this.props.showInModal
            ) {
                viewMore = (
                    <IconRelatedIcons
                        icon={this.props.icon}
                        iconId={this.props.iconId}
                        className="container"
                    />
                );
            }

            let mobileTags = (
                <div className="mobile-tags show-sm">
                    <IconTags icon={this.props.icon} />
                </div>
            );

            let containerClass = classnames("view-container");

            return (
                <section
                    data-test-id="icon-hero"
                    id="np-icon-hero-test"
                    className="nounproject-icon-hero"
                    ref={this.setContainerEl}
                >
                    <div className="hero-page-width-container margin-b-m">
                        {superUserActions}
                        <div className={containerClass}>
                            {heroPreview}
                            {heroEditing}
                        </div>
                        {heroMeta}
                        <div className="download-icon-actions">
                            {closeButton}
                            <IconShare
                                history={this.props.history}
                                icon={this.props.icon}
                                downloadFlowNavigateToModalStep={
                                    this.props.downloadFlowNavigateToModalStep
                                }
                            />
                        </div>
                    </div>
                    {viewMore}
                    {mobileTags}
                </section>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state, props) {
    let { download, stripe, modal } = state;

    let { status, license, usingPremiumFeatures, isPremiumUser } = download;

    let apiResponse = state.apiResponse,
        icon,
        currentUser;

    if (
        download &&
        props.icon &&
        download.pendingDownload &&
        download.pendingDownload.id == props.icon.id
    ) {
        icon = download.pendingDownload;
    } else {
        icon = props.icon;
    }

    if (!icon) {
        let { icons } = state;
        let storedIcon = icons[props.iconId];
        if (storedIcon) {
            icon = storedIcon;
        }
    }

    let isAnonymous = true;
    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
        isAnonymous = currentUser.is_anonymous;
    }

    let processing = download.processing || stripe.processing;

    let modalOpen = modal && modal.all && Object.keys(modal.all).length;

    return {
        status,
        apiResponse,
        icon,
        currentUser,
        isAnonymous,
        license,
        usingPremiumFeatures,
        isPremiumUser,
        processing,
        download,
        modalOpen
    };
}

export default withRouter(
    connect(mapStateToProps, {
        uiScrollToElement: actions.uiScrollToElement,
        showModal: actions.showModal,
        dismissModal: actions.dismissModal,
        downloadSetFlowActive: actions.downloadSetFlowActive,
        downloadFlowModalStep: actions.downloadFlowModalStep,
        downloadFlowHideModal: actions.downloadFlowHideModal,
        downloadFlowNavigateToModalStep: actions.downloadFlowNavigateToModalStep
    })(NounProjectIconHero)
);
